import React from 'react';
import * as Render from '../../platformui/Base/Render';
import ArticlePage from '../../platformui/Pages/article';
import * as Blocks from '../../blocks';
import ArticleTools from '../../components/c-article-tools';
import Rating from '../../components/c-rating';
import MatomoTrackDataAttribute from '../../platformui/Matomo/matomo-track-data-attribute';
import MatomoTrackMediaAnalytics from '../../platformui/Matomo/matomo-track-media-analytics';

const blockTypes = <Render.BlockTypeRenderer Blocks={Blocks} />;
export default (props) => (
  <>
    <ArticlePage
      {...props}
      contentDirection={props.Site === 'umo' ? 'rows' : null}
      BlockTypeRenderer={blockTypes}
      SubjectAboveHeading={true}
      ArticleTools={ArticleTools}
      RatingComponent={
        <Rating FeedbackRatingModel={props.FeedbackRatingModel} />
      }
    />
    <MatomoTrackMediaAnalytics />
    <MatomoTrackDataAttribute />
  </>
);
